import { Directive, HostListener, Input } from '@angular/core';
import { Validations } from '../constants/validations.constant';

@Directive({
  selector: '[allowAlphaNumeric]'
})
export class AllowAlphaNumericSchemaDirective {

  @Input() allowAlphaNumeric!:boolean;

  @HostListener('keydown', ['$event']) onInputChange(event:any) {
    if(this.allowAlphaNumeric){
      const alphaNumericRegex = new RegExp(Validations.REGEX_ALPHANUMERIC_SPACES_HYPHEN);
      return alphaNumericRegex.test(event.key);
    }
    return true;
  }
}
